import $ from "cash-dom";
import anime from "animejs/lib/anime.es.js";

export const cardComponent = () => {
    $('.card').each((_, card) => {
        const $card = $(card);
        const $content = $card.find('.card-content');
        const $arrow = $card.find('.card-arrow');
        const $arrowHover = $card.find('.card-arrow-hover');

        card.onmouseenter = () => {
            anime({
                targets: $arrowHover.get(0),
                opacity: 1,
                duration: 100,
                easing: 'easeInOutSine',
            })
        };

        card.onmouseleave = () => {
            anime({
                targets: $arrowHover.get(0),
                opacity: 0,
                duration: 100,
                easing: 'easeInSine',
            })
        };

        card.onclick = () => {
            $content.toggleClass('hidden');
            $arrow.toggleClass('-scale-y-100');
        };
    });
};
